import React from 'react';

interface FormLabelProps extends React.HTMLProps<HTMLInputElement> {
    htmlFor: string;
    text: string;
}

export default class Label extends React.Component<FormLabelProps> {
    render() {
        if (this.props.text === '') {
            return null;
        }
        return (
            <label
                htmlFor={this.props.htmlFor}
                dangerouslySetInnerHTML={{ __html: this.props.text }}
            />
        );
    }
}
